import React, { useState, useEffect } from "react"
import axios from "axios"
import Grid from "@material-ui/core/Grid"

import { checkTokenExpirationMiddleware } from "../../../middlewares/users-auth.middleware"
import RequestCard from "./request-card"

const Feed = () => {
  const [reservationRequests, setReservationRequests] = useState(null)
  const [loading, setLoading] = useState(true)
  const [user] = useState(checkTokenExpirationMiddleware())
  const [, setError] = useState(null)

  useEffect(() => {
    let headers = {
      Authorization: `Bearer ${user.Token}`
    }

    axios
      .get(`${process.env.REACT_APP_API}/api/requests`, { headers: headers })
      .then(res => {
        setReservationRequests(res.data)
        setTimeout(() => setLoading(false), 750)
      })
      .catch(err => {
        setError({ error: "Error Loading page" })
      })
  }, [])

  return (
    <>
      <Grid container item xs={12} justify="center" spacing={3} className={`${loading ? "overflow-hidden" : ""}`}>
        <Grid container item className="card-wrapper">
          {reservationRequests && loading === false ? <>{reservationRequests.length > 0 ? reservationRequests.map((reservationRequest, index) => <RequestCard key={index} loading={loading} reservationRequest={reservationRequest} />) : <>No More Requests to show</>}</> : [1, 2, 3, 4].map((skeleton, index) => <RequestCard key={index} loading={loading} reservationRequest={null} />)}
        </Grid>
      </Grid>
    </>
  )
}

export default Feed
